import { useAuth } from "../App";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logoIcon from "../assets/Logo.png";
import { useState } from "react";

const NAV_ITEMS = [
  { path: "/dashboard", icon: "🏠", label: "Dashboard" },
  { path: "/template",  icon: "📋", label: "Template Kode" },
  { path: "/chatbot",   icon: "🤖", label: "Chatbot AI" },
  { path: "/profil",    icon: "👤", label: "Profil Saya" },
  { path: "/kuisioner", icon: "📝", label: "Kuisioner" },
];

const PAGE_TITLES = {
  "/dashboard": "Dashboard",
  "/template":  "Template Kode",
  "/chatbot":   "Chatbot AI",
  "/profil":    "Profil Saya",
  "/tentang":   "Tentang Aplikasi",
  "/bantuan":   "Pusat Bantuan",
  "/kuisioner": "Kuisioner Kepuasan",
};

function getInitials(name) {
  if (!name) return "?";
  return name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
}

export default function DashboardLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    if (window.confirm("Keluar dari akun?")) {
      logout();
      navigate("/login");
    }
  };

  return (
    <div className="dash-root">
      {/* ── Sidebar ── */}
      <aside className={`dash-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="dash-sidebar-header">
          <img src={logoIcon} alt="AiDuNode" className="dash-sidebar-logo" />
          <span className="dash-sidebar-brand">AiDuNode</span>
        </div>

        <nav className="dash-nav">
          {NAV_ITEMS.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`dash-nav-item ${location.pathname === item.path ? "active" : ""}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="dash-nav-icon">{item.icon}</span>
              <span className="dash-nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="dash-sidebar-footer">
          <div className="dash-user-row">
            <div className="dash-user-avatar">{getInitials(user?.name)}</div>
            <div className="dash-user-info">
              <p className="dash-user-name">{user?.name || "User"}</p>
              <p className="dash-user-email">{user?.email || ""}</p>
            </div>
          </div>
          <button className="dash-logout-btn" onClick={handleLogout}>
            🚪 Keluar
          </button>
        </div>
      </aside>

      {/* ── Overlay mobile ── */}
      {sidebarOpen && (
        <div className="dash-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Main content ── */}
      <div className="dash-main">
        {/* Topbar */}
        <header className="dash-topbar">
          <button className="dash-hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>
            <span /><span /><span />
          </button>
          <span className="dash-topbar-title">
            {PAGE_TITLES[location.pathname] || "AiDuNode"}
          </span>
          <div className="dash-topbar-right">
            <div className="dash-user-avatar sm">{getInitials(user?.name)}</div>
          </div>
        </header>

        {/* Page content */}
        <main className="dash-content">
          {children}
        </main>
      </div>
    </div>
  );
}
